import api from './api';

const MAIL_OPERATION_TIMEOUT = 30000;

export interface AppUser {
  id: number;
  username: string;
  email?: string | null;
  nom?: string | null;
  role: string;
  mustChangePassword: boolean;
}

export interface CreateAgentPayload {
  username: string;
  email: string;
  nom?: string;
  role: 'ROLE_AGENT' | 'ROLE_SUPER_AGENT';
}

/** Empty / omitted fields are left unchanged. */
export interface UpdateCredentialsPayload {
  username?: string;
  newPassword?: string;
  mustChangePassword?: boolean;
}

export const userService = {
  list: () => api.get<AppUser[]>('/api/users').then((r) => r.data),
  createAgent: (payload: CreateAgentPayload) =>
    api.post<AppUser>('/api/users', payload, { timeout: MAIL_OPERATION_TIMEOUT }).then((r) => r.data),
  updateCredentials: (id: number, payload: UpdateCredentialsPayload) =>
    api.put<AppUser>(`/api/users/${id}/credentials`, payload).then((r) => r.data),
  resetPassword: (id: number) =>
    api.post(`/api/users/${id}/reset-password`, undefined, { timeout: MAIL_OPERATION_TIMEOUT }),
};
